import { useEffect, useState } from "react";
import { Button, Card, Input, List, Popconfirm, Space, Typography, message } from "antd";
import { BankOutlined, DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import Footer from "../../../components/Footer";
import NavBar from "../../../components/NavBar";
import SideBar from "../../../components/SideBar";
import axiosInstance from "../../../variables/api/axiosInstance";

const { Title, Text } = Typography;

/**
 * Paramétrage des juridictions / tribunaux (type de paramètre JURIDICTION). Alimente la mise en
 * contentieux des sinistres (sélection de la juridiction) et les filtres des états contentieux.
 */
const Juridictions = () => {
    const [juridictions, setJuridictions] = useState([]);
    const [libelle, setLibelle] = useState("");
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);

    const load = () => {
        setLoading(true);
        axiosInstance.get("/api/parametre/type/JURIDICTION")
            .then((res) => setJuridictions(res.data || []))
            .catch(() => message.error("Erreur lors du chargement des juridictions."))
            .finally(() => setLoading(false));
    };
    useEffect(() => { load(); }, []);

    const ajouter = () => {
        const nom = libelle.trim();
        if (!nom) return;
        if (juridictions.some((j) => (j.libelleParametre || "").toLowerCase() === nom.toLowerCase())) {
            message.warning("Cette juridiction existe déjà.");
            return;
        }
        setSaving(true);
        axiosInstance.post("/api/parametre", JSON.stringify({ typeParametre: "JURIDICTION", libelleParametre: nom }),
            { headers: { "Content-Type": "application/json" } })
            .then(() => { setLibelle(""); message.success("Juridiction ajoutée."); load(); })
            .catch(() => message.error("Erreur lors de l'ajout."))
            .finally(() => setSaving(false));
    };

    const supprimer = (id) => {
        axiosInstance.delete(`/api/parametre/${id}`)
            .then(() => { message.success("Juridiction supprimée."); load(); })
            .catch(() => message.error("Erreur lors de la suppression."));
    };

    return (
        <div className="layout-wrapper layout-content-navbar">
            <div className="layout-container">
                <SideBar currentMenu={"PARAMETRES"} />
                <div className="layout-page">
                    <NavBar />
                    <div className="content-wrapper">
                        <div className="container-xxl flex-grow-1 container-p-y">
                            <Title level={3}><BankOutlined /> Paramétrage des juridictions</Title>
                            <Text type="secondary">Tribunaux utilisés pour la mise en contentieux des sinistres.</Text>

                            <Card style={{ borderRadius: 12, marginTop: 16, maxWidth: 640 }}>
                                <Space.Compact style={{ width: "100%" }}>
                                    <Input
                                        placeholder="Nom de la juridiction (ex. LOMÉ, KPALIMÉ, ATAKPAMÉ…)"
                                        value={libelle}
                                        onChange={(e) => setLibelle(e.target.value)}
                                        onPressEnter={ajouter}
                                    />
                                    <Button type="primary" icon={<PlusOutlined />} loading={saving} onClick={ajouter}>
                                        Ajouter
                                    </Button>
                                </Space.Compact>

                                <List
                                    style={{ marginTop: 16 }}
                                    loading={loading}
                                    bordered
                                    dataSource={juridictions}
                                    locale={{ emptyText: "Aucune juridiction" }}
                                    renderItem={(j) => (
                                        <List.Item
                                            actions={[
                                                <Popconfirm
                                                    key="del"
                                                    title="Supprimer cette juridiction ?"
                                                    onConfirm={() => supprimer(j.parametreId)}
                                                    okText="Oui" cancelText="Non"
                                                >
                                                    <Button type="text" danger icon={<DeleteOutlined />} />
                                                </Popconfirm>,
                                            ]}
                                        >
                                            {j.libelleParametre}
                                        </List.Item>
                                    )}
                                />
                            </Card>
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Juridictions;
